(function () {
  function animateCount(el, target) {
    var start = parseInt((el.textContent || '0').replace(/[^0-9]/g, ''), 10) || 0;
    if (start === target) {
      el.textContent = target.toLocaleString();
      return;
    }
    var duration = 900;
    var startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var value = Math.round(start + (target - start) * progress);
      el.textContent = value.toLocaleString();
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initYouTubeLive(root) {
    if (!root || root.dataset.youtubeInitialized === 'true') return;
    root.dataset.youtubeInitialized = 'true';

    var countEl = root.querySelector('[data-youtube-count]');
    var videosEl = root.querySelector('[data-youtube-videos]');
    var apiKey = root.dataset.youtubeApiKey;
    var handle = root.dataset.youtubeHandle;
    var maxResults = parseInt(root.dataset.youtubeMaxResults, 10) || 3;
    if (!apiKey || !handle) return;

    var channelsUrl =
      'https://www.googleapis.com/youtube/v3/channels?part=statistics,contentDetails&forHandle=' +
      encodeURIComponent(handle) +
      '&key=' +
      encodeURIComponent(apiKey);

    fetch(channelsUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var channel = data.items && data.items[0];
        if (!channel) return;

        if (countEl && channel.statistics && channel.statistics.subscriberCount) {
          animateCount(countEl, parseInt(channel.statistics.subscriberCount, 10));
        }

        var uploadsId =
          channel.contentDetails &&
          channel.contentDetails.relatedPlaylists &&
          channel.contentDetails.relatedPlaylists.uploads;

        if (videosEl && uploadsId) {
          var playlistUrl =
            'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=' +
            encodeURIComponent(maxResults) +
            '&playlistId=' +
            encodeURIComponent(uploadsId) +
            '&key=' +
            encodeURIComponent(apiKey);

          fetch(playlistUrl)
            .then(function (r) { return r.json(); })
            .then(function (vdata) {
              if (!vdata.items || !vdata.items.length) return;
              videosEl.innerHTML = vdata.items
                .map(function (item) {
                  var s = item.snippet;
                  if (!s || !s.resourceId) return '';
                  var vid = s.resourceId.videoId;
                  var thumb =
                    (s.thumbnails && (s.thumbnails.medium || s.thumbnails.default) || {}).url || '';
                  return (
                    '<a class="social-follow__short" href="https://www.youtube.com/watch?v=' +
                    encodeURIComponent(vid) +
                    '" target="_blank" rel="noopener">' +
                    (thumb ? '<img src="' + thumb + '" alt="" loading="lazy">' : '') +
                    '<span>' +
                    escapeHtml(s.title) +
                    '</span></a>'
                  );
                })
                .join('');
            })
            .catch(function () {});
        }
      })
      .catch(function () {
        /* Network/API error - static fallback numbers already rendered stay visible */
      });
  }

  function initAll() {
    document.querySelectorAll('[data-social-follow]').forEach(initYouTubeLive);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-social-follow]') : null;
    if (root) initYouTubeLive(root);
  });
})();
